import "../scss/style.scss";
import "./top.js";

$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  // スクロール先
  const position = target.offset().top;
  const scrollMargin = parseInt(target.css('scroll-margin-top')) || 0;
  $('html, body').animate({ scrollTop: position + scrollMargin }, speed, easing);
  return false;
});

$(function () {
  $(window).on("load scroll", function () {
    if ($(window).scrollTop() > 100) {
      $('.totop').fadeIn();
    } else {
      $('.totop').fadeOut();
    }

    $(".js-fadeUp").each(function () {
      const target = $(this);
      const targetOffset = target.offset().top;
      const windowHeight = $(window).height();
      const scrollPosition = $(window).scrollTop();
      const targetPosition = targetOffset - windowHeight;
      if (scrollPosition > targetPosition) {
        target.addClass("is-fadeUp");
      } else {
        target.removeClass("is-fadeUp");
      }
    });
  });
});
